import type { ModalTriggerProps } from '@ztechapps/webui.modal'
import { BusyButton } from '@ztechapps/webui.button'
import { useRole } from '@ztechapps/common.hook'
import { blogPermissions } from '@ztechapps/blog.common'

export const AddNewButton = ({ onClick }: ModalTriggerProps) => {
  const { hasRole } = useRole({ roleName: blogPermissions.canEdit.value })

  return (
    <BusyButton
      {...{
        icon: 'plus',
        onClick,
        text: 'Add new blog...',
        title: 'Add new blog.',
        disabledReason: hasRole ? undefined : 'You do not have permission to add new blog',
      }}
    />
  )
}
